import { Endpoint } from "../config";

export type FilesEndpointType =
  | "upload"
  | "download"
  | "delete"
  | "preview";

export const filesEndpoints: Record<FilesEndpointType, Endpoint> = {
  upload: {
    url: "files/upload/",
  },
  download: {
    url: "files/:id/download/",
  },
  delete: {
    url: "files/:id/",
  },
  preview: {
    url: "files/:id/preview/",
  },
};